/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BeneficiaryDto } from './BeneficiaryDto';
import {
    BeneficiaryDtoFromJSON,
    BeneficiaryDtoFromJSONTyped,
    BeneficiaryDtoToJSON,
    BeneficiaryDtoToJSONTyped,
} from './BeneficiaryDto';

/**
 * 
 * @export
 * @interface GetBeneficiariesResponse
 */
export interface GetBeneficiariesResponse {
    /**
     * 
     * @type {Array<BeneficiaryDto>}
     * @memberof GetBeneficiariesResponse
     */
    items: Array<BeneficiaryDto>;
}

/**
 * Check if a given object implements the GetBeneficiariesResponse interface.
 */
export function instanceOfGetBeneficiariesResponse(value: object): value is GetBeneficiariesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetBeneficiariesResponseFromJSON(json: any): GetBeneficiariesResponse {
    return GetBeneficiariesResponseFromJSONTyped(json, false);
}

export function GetBeneficiariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBeneficiariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BeneficiaryDtoFromJSON)),
    };
}

export function GetBeneficiariesResponseToJSON(json: any): GetBeneficiariesResponse {
    return GetBeneficiariesResponseToJSONTyped(json, false);
}

export function GetBeneficiariesResponseToJSONTyped(value?: GetBeneficiariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(BeneficiaryDtoToJSON)),
    };
}

